import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getNotificationServices({ commit, dispatch, getters }) {
    return axios.get(`/api/end_user/notificationServices`).then((response) => {
      return response.data
    })
  },
}
